export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"
export const INIT_LOGIN = "INIT_LOGIN"
export const LOGIN_GET_VERIFICATION = "LOGIN_GET_VERIFICATION"

export const PENDING = "_PENDING"
export const FULFILLED = "_FULFILLED"
export const REJECTED = "_REJECTED"
